import React from 'react';

class Images extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      photoTypes: [{
        type: 'headshot',
        url: null
      }, {
        type: 'idFront',
        url: null
      }]
    }
  }

  componentDidMount() {
    const { session } = this.props;
    const photoTypes = [...this.state.photoTypes];
    const { photos } = session;

    if (photos) {
      photoTypes.forEach(photoType => {
        if (!photos[photoType.type]) {
          return;
        }

        if (photos[photoType.type].original && photos[photoType.type].original[0]) {
          photoType.url = photos[photoType.type].original[0].url;
        } else if (photos[photoType.type].large && photos[photoType.type].large[0]) {
          photoType.url = photos[photoType.type].large[0].url;
        } else if (photos[photoType.type].small && photos[photoType.type].small[0]) {
          photoType.url = photos[photoType.type].small[0].url;
        }
      });

      this.setState({
        photoTypes
      });
    }
  }

  handleClick(img, alt) {
    const { AppStore } = this.props.store;

    AppStore.showModal({
      type: 'image',
      img,
      alt
    });
  }

  render() {
    const { translation } = this.props;
    const { photoTypes } = this.state;

    return (
      <section>
        <h2 className="meta">{translation.title}</h2>

        {photoTypes.map(
          (photo, i) => {
            if (photo.url) {
              return (
                <figure
                  className="photo"
                  key={i}
                >
                  <figcaption className="photo__caption">
                    {translation[photo.type]}
                  </figcaption>

                  <img
                    className="photo__img photo__img--clickable"
                    src={photo.url}
                    alt={translation[photo.type]}
                    onClick={() => this.handleClick(photo.url, translation[photo.type])}
                  />
                </figure>
              )
            }

            return null;
          }
        )}
      </section>
    )
  }
}

export default Images;
